module.exports = "https://coursera_assets.s3.amazonaws.com/images/9589178a03435017b40a7e348c3bcfc0.jpg";